(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hardware-component-kit"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-component-kit]');
  var core = window.KnoxHardwarePurchase;
  if (!root || !core) return;
  var galleryControls = root.querySelector('[data-kit-gallery-controls]');
  if (galleryControls) {
    galleryControls.hidden = false;
    galleryControls.querySelectorAll('[data-kit-gallery-index]').forEach(function (button) {
      button.addEventListener('click', function () {
        root.querySelectorAll('[data-kit-view]').forEach(function (view) {view.hidden = view.dataset.kitView !== button.dataset.kitGalleryIndex;});
        galleryControls.querySelectorAll('[data-kit-gallery-index]').forEach(function (control) {control.setAttribute('aria-pressed', control === button ? 'true' : 'false');});
      });
    });
  }
  var data = JSON.parse(root.querySelector('[data-kit-data]').textContent);
  var cards = Array.from(root.querySelectorAll('[data-kit-component]'));
  var input = root.querySelector('[data-kit-quantity]');
  var add = root.querySelector('[data-kit-add]');
  var pending = false;
  var money = new Intl.NumberFormat(data.locale, {style:'currency',currency:data.currency});
  var main = {mode:'buyable'};
  function count() {return core.quantity(input.value,1,99);}
  function lines() {
    return cards.map(function (card) {
      var line = JSON.parse(card.querySelector('[data-kit-line]').textContent);
      line.quantity = Number(card.dataset.units) * count();
      var terms = card.querySelector('[data-kit-terms-check]');
      var text = card.querySelector('[data-kit-terms-text]');
      line.agreement = terms && text ? {accepted:terms.checked,html:text.innerHTML,text:text.textContent,productId:line.productId,title:line.title,handle:line.handle} : null;
      return line;
    });
  }
  function render() {
    var selected = lines();
    var assessment = core.assess(main,selected,null,pending);
    add.disabled = !assessment.canCart || selected.length !== 3;
    add.textContent = pending ? data.adding : data.button;
    input.disabled = pending;
    root.querySelectorAll('[data-kit-minus],[data-kit-plus],[data-kit-terms-check]').forEach(function (el) {el.disabled=pending;});
    root.querySelector('[data-kit-status]').textContent = data[assessment.reason] || '';
    root.querySelector('[data-kit-total]').textContent = assessment.showPrices ? money.format(assessment.total/100) : data.quote_required;
    root.querySelector('[data-kit-unit-price]').textContent = assessment.showPrices ? money.format(assessment.total/count()/100) : data.quote_required;
    cards.forEach(function (card,i) {card.querySelector('[data-kit-line-quantity]').textContent=selected[i].quantity;card.querySelector('[data-kit-line-price]').textContent=assessment.showPrices?money.format(selected[i].priceCents*selected[i].quantity/100):'';});
  }
  function setCount(value) {if(pending)return;input.value=core.quantity(value,1,99);render();}
  input.addEventListener('change',function(){setCount(input.value);});
  root.querySelector('[data-kit-minus]').addEventListener('click',function(){setCount(count()-1);});
  root.querySelector('[data-kit-plus]').addEventListener('click',function(){setCount(count()+1);});
  root.querySelectorAll('[data-kit-terms-check]').forEach(function(el){el.addEventListener('change',render);});
  add.addEventListener('click',async function(){
    var selected=lines();
    if(!core.assess(main,selected,null,pending).canCart || selected.length !== 3)return;
    var items=core.cartItems(main,selected,null,data.handle+'-'+Date.now().toString(36),new Date().toISOString());
    items.forEach(function(item){item.properties.Kit=data.title;});
    var error=root.querySelector('[data-kit-error]');
    error.hidden=true;pending=true;render();
    try{
      var response=await fetch(data.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})});
      var payload=await response.json();
      if(!response.ok)throw new Error(typeof payload.description==='string'?payload.description:data.cart_error);
      window.location.assign(data.cartUrl);
    }catch(failure){pending=false;render();error.textContent=failure.message || data.cart_error;error.hidden=false;}
  });
  render();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knox-campaign-landing"] && !Shopify.designMode) return;
  try {
    
  var contactSection = document.getElementById('klc-enquire');
  var heroSection = document.querySelector('.klc-hero');
  var mobileCta = document.querySelector('.klc-mobile-cta');
  if (contactSection && heroSection && mobileCta) {
    var updateMobileCta = function () {
      var pastHero = heroSection.getBoundingClientRect().bottom < 0;
      var beforeContact = contactSection.getBoundingClientRect().top > window.innerHeight * 0.75;
      mobileCta.classList.toggle('klc-mobile-cta--visible', pastHero && beforeContact);
    };
    window.addEventListener('scroll', updateMobileCta, { passive: true });
    window.addEventListener('resize', updateMobileCta);
    updateMobileCta();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knoxlabs-brand-catalog"] && !Shopify.designMode) return;
  try {
    
(()=>{const initialize=scope=>scope.querySelectorAll('[data-knoxlabs-catalog]').forEach(catalog=>{if(catalog.dataset.ready)return;const rows=Array.from(catalog.querySelectorAll('[data-knoxlabs-row]'));const type=catalog.querySelector('[data-knoxlabs-type]');const status=catalog.querySelector('[data-knoxlabs-status]');if(!rows.length||!type||!status)return;catalog.dataset.ready='true';[...new Set(rows.map(row=>row.dataset.type))].sort((a,b)=>a.localeCompare(b)).forEach(name=>{const option=document.createElement('option');option.value=name;option.textContent=name;type.appendChild(option)});const update=()=>{let shown=0;rows.forEach(row=>{row.hidden=Boolean(type.value&&row.dataset.type!==type.value);if(!row.hidden)shown++});status.textContent=status.dataset.template.replace('[shown]',shown).replace('[total]',rows.length)};type.addEventListener('change',update);catalog.querySelector('[data-knoxlabs-reset]').addEventListener('click',()=>{type.value='';update()});catalog.querySelector('[data-knoxlabs-tools]').hidden=false;status.hidden=false;update()});initialize(document);document.addEventListener('shopify:section:load',event=>initialize(event.target))})();

  } catch(e) { console.error(e); }
})();
})();
